import axios from '@/libs/api.request'

getrank
export const getrank = (anow) => {
  return axios.request({
    url: '/v1/weixin/project_rank/',
    method: 'get'
  })
}
export const getvote = (anow) => {
    return axios.request({
        url: '/v1/weixin/activity_project/',
        method: 'get',
      params: {
        anow
      }
    })
}
export const getplist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/weixin/project/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}


export const votechange = (pid,change) => {
  return axios.request({
    url: '/v1/weixin/votechange/',
    method: 'get',
    params: {
      pid,
      change
    }
  })
}
